export default __webpack_public_path__ + "static/media/Flag of Saint Helena, Ascension, and Tristan da Cunha.d2ebb27a.gif";